import "./Reviews01.css";

import tyres from "./../../../img/cont/tyres-1.webp";
import user01 from "./../../../img/other/user-1.png";
import user02 from "./../../../img/other/user-2.png";
import user03 from "./../../../img/other/user-3.png";
import user04 from "./../../../img/other/user-4.png";

import stars from "./../../../img/icons/stars.png";

function Reviews01() {
  return (
    <div className="Reviews01 section" id="Reviews01">
      <div className="container">
        <div className="Reviews01-box">
          <div className="Reviews01-text">
            <p className="eyebrow green">our Reviews </p>
            <h2>See what our clients say about us</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </div>

          <div className="Reviews01-list">
            <div className="Reviews01-list-slider">
              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user01} alt="" />

                  <div>
                    <h4>Mark S. </h4>
                    <p className="small-font">Service Manager</p>
                  </div>
                </div>

                <p>
                  Their scheduled collections are always on time, the drivers
                  are professional, and the paperwork is handled flawlessly.
                  It’s a completely hassle-free service that I'd recommend to
                  anyone in the motor trade.
                </p>

                <img src={stars} alt="" />
              </div>

              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user02} alt="" />

                  <div>
                    <h4>David M.</h4>
                    <p className="small-font">Miller's Farm</p>
                  </div>
                </div>

                <p>
                  Getting rid of old tractor tyres used to be a real headache.
                  GTR made it simple. They came out to the farm in South
                  Derbyshire, gave us a fair quote, and handled the big, heavy
                  tyres with no problem at all.
                </p>

                <img src={stars} alt="" />
              </div>

              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user03} alt="" />

                  <div>
                    <h4>Andrei K.</h4>
                    <p className="small-font">General Manager</p>
                  </div>
                </div>

                <p>
                  As a small courier business, we don't have a huge volume of
                  tyres, but GTR treats us with the same professionalism as a
                  big garage. Scheduling a collection is easy, and it’s a relief
                  to have a compliant way to manage our waste.
                </p>

                <img src={stars} alt="" />
              </div>

              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user04} alt="" />

                  <div>
                    <h4>Steve P.</h4>
                    <p className="small-font">Business Owner</p>
                  </div>
                </div>

                <p>
                  We accumulate a massive number of end-of-life tyres here.
                  Global Tyres Recycling is the only company we trust to clear
                  them. They can handle the large volume and provide all the
                  correct paperwork without fail.
                </p>

                <img src={stars} alt="" />
              </div>
            </div>

            <div className="Reviews01-list-slider">
              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user01} alt="" />

                  <div>
                    <h4>Mark S. </h4>
                    <p className="small-font">Service Manager</p>
                  </div>
                </div>

                <p>
                  Their scheduled collections are always on time, the drivers
                  are professional, and the paperwork is handled flawlessly.
                  It’s a completely hassle-free service that I'd recommend to
                  anyone in the motor trade.
                </p>

                <img src={stars} alt="" />
              </div>

              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user02} alt="" />

                  <div>
                    <h4>David M.</h4>
                    <p className="small-font">Miller's Farm</p>
                  </div>
                </div>

                <p>
                  Getting rid of old tractor tyres used to be a real headache.
                  GTR made it simple. They came out to the farm in South
                  Derbyshire, gave us a fair quote, and handled the big, heavy
                  tyres with no problem at all.
                </p>

                <img src={stars} alt="" />
              </div>

              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user03} alt="" />

                  <div>
                    <h4>Andrei K.</h4>
                    <p className="small-font">General Manager</p>
                  </div>
                </div>

                <p>
                  As a small courier business, we don't have a huge volume of
                  tyres, but GTR treats us with the same professionalism as a
                  big garage. Scheduling a collection is easy, and it’s a relief
                  to have a compliant way to manage our waste.
                </p>

                <img src={stars} alt="" />
              </div>

              <div className="Reviews01-list-item">
                <div className="Reviews01-list-top">
                  <img src={user04} alt="" />

                  <div>
                    <h4>Steve P.</h4>
                    <p className="small-font">Business Owner</p>
                  </div>
                </div>

                <p>
                  We accumulate a massive number of end-of-life tyres here.
                  Global Tyres Recycling is the only company we trust to clear
                  them. They can handle the large volume and provide all the
                  correct paperwork without fail.
                </p>

                <img src={stars} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reviews01;
